import { format } from "date-fns";
import { pascalCase } from "pascal-case";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../redux/authSlice";
import { addSurvey, surveySelector } from "../../redux/surveySlice";
const InspectionCard = ({ survey }) => {
  const dispatch = useDispatch();
  const sSurvey = useSelector(surveySelector);
  return (
    <>
      <div
        className={`cardInspection mb-3 ${
          sSurvey.id === survey.id ? "active" : ""
        }`}
        onClick={() => dispatch(addSurvey(survey))}
      >
        <div className="media-header">
          <div className="media-body">
            <h4>{survey.hdcAssetReference}</h4>
          </div>

          <div className="status">
            {survey.status && pascalCase(survey.status)}
          </div>
        </div>
        <div className="cardBody">
          <div className="address">{survey.address}</div>
          <ul className="tagList">
            <li>
              <span className="tags">WHE Ref:{survey.wheRef}</span>
            </li>
            <li>
              <span className="tags">Client Ref:{survey.clientRef}</span>
            </li>
          </ul>

          <div className="surveyorInfo">
            <Row>
              <Col xxl="6">
                Inspector: <span>{survey.surveyorName}</span>
              </Col>
              <Col xxl="6" className="text-xxl-end">
                Author: <span>{survey.adminName}</span>
              </Col>
            </Row>
          </div>
        </div>
        <div className="cardFooter">
          Inspection Date:{" "}
          {survey.inspectionDate
            ? format(new Date(survey.inspectionDate), "dd/MM/yyyy")
            : format(new Date(), "dd/MM/yyyy")}
        </div>
      </div>
    </>
  );
};

export default InspectionCard;
